module.exports = __webpack_public_path__ + "img/zuo2.d65eace4.png";